import type { MouseEvent, ReactNode } from 'react';

import './profile-link.css';

export function carrierProfileHash(profileId: number | null | undefined): string | null {
  return profileId ? `#carrier-profile-external?id=${profileId}` : null;
}

export function customerProfileHash(profileId: number | null | undefined): string | null {
  return profileId ? `#profile-external?customer=${profileId}` : null;
}

export interface ProfileLinkProps {
  role: 'carrier' | 'customer';
  profileId: number | null | undefined;
  className?: string;
  children: ReactNode;
}

export function ProfileLink({ role, profileId, className, children }: ProfileLinkProps) {
  const href = role === 'carrier' ? carrierProfileHash(profileId) : customerProfileHash(profileId);
  if (!href) return <>{children}</>;
  return (
    <a
      className={`profile-link${className ? ` ${className}` : ''}`}
      href={href}
      onClick={(event: MouseEvent) => event.stopPropagation()}
    >
      {children}
    </a>
  );
}
